import React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"
import { Location } from "@reach/router"

import { Toolbar } from "@material-ui/core"
import CloseIcon from "@material-ui/icons/Close"

import { withStyles } from "@material-ui/styles"
import MenuIcon from "@material-ui/icons/Menu"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSun, faCloud } from "@fortawesome/free-solid-svg-icons"

import Drawer from "./Drawer"
import NavMenu from "./NavMenu"

import Logowhite from "../../img/archie_logo_white.png"
import Logoblack from "../../img/archie_logo_black.png"

import "./Nav.scss"
import "./ToggleButton.scss"


const styles = () => ({
  appBar: {
    backgroundColor: "#0b365a"
  },
  toolBar: {
    height: "100%",
  }
})


class Nav extends React.Component {
  constructor(props) {
    super(props)
    this.state = {open: true, hover: false}
    this.openDrawer = this.openDrawer.bind(this)
    this.closeDrawer = this.closeDrawer.bind(this)
    this.toggleDrawer = this.toggleDrawer.bind(this)
    this.toggleDarkMode = this.toggleDarkMode.bind(this)
  }

  openDrawer() {
    this.props.onToggle({open: true})
    this.setState({open: true})
  }

  closeDrawer() {
    this.props.onToggle({open: false, activeNavComponents: []})
    this.setState({open: false})
  }

  toggleDrawer() {
    this.props.onToggle({open: !this.state.open})
    this.setState({open: !this.state.open})
  }

  toggleDarkMode() {
    this.props.onToggleDarkMode()
  }

  render() {
    const { classes, darkMode } = this.props
    return (
      <nav className="nav">
        <div className={`nav__bar nav__bar--${this.state.open ? "open" : "closed"}`}>
          <Toolbar className={classes.toolBar}>
            <div className="nav__menu-btn-wrapper">
              <button
                className="nav__menu-btn"
                color="inherit"
                aria-label="toggle drawer"
                onClick={this.toggleDrawer}
                edge="start"
              >
                <MenuIcon />
              </button>

            </div>
            <div className="nav__menu-btn-wrapper">
              <div className="toggle">
                <span className="toggle__label">
                  <FontAwesomeIcon icon={darkMode ? faCloud : faSun}/>
                </span>
                <input
                  id="darkToggle"
                  className="toggle__control"
                  type="checkbox"
                  onChange={this.toggleDarkMode}
                  checked={darkMode}
                />
                <label className="toggle__button" htmlFor="darkToggle"></label>
              </div>
            </div>
          </Toolbar>
        </div>

        <Drawer
          open={this.state.open}
          onMouseEnter={() => this.setState({hover: true})}
          onMouseLeave={() => this.setState({hover: false})}
        >
          <div className="nav__drawer-header">
            <Link className="nav__logo-link" to="/">
              <img className="nav__logo" height={50} src={darkMode ? Logowhite : Logoblack} alt="Cloudbuddies"/>
            </Link>
            <div className="nav__drawer-close-btn">
              <button className="nav__menu-btn" onClick={this.closeDrawer}>
                <CloseIcon/>
              </button>
            </div>
          </div>
          {/*<Divider />*/}
          <Location>
            {
              locationProps => (
                <NavMenu open={this.state.open || this.state.hover} path={locationProps.location}/>
              )
            }
          </Location>
        </Drawer>
      </nav>
    )
  }
}

Nav.propTypes = {
  classes: PropTypes.object,
  onToggle: PropTypes.func,
  onToggleDarkMode: PropTypes.func,
  darkMode: PropTypes.bool,
}

Nav.defaultProps = {
  onToggle: () => {},
  onToggleDarkMode: () => {},
  darkMode: true,
}


export { Nav }

export default withStyles(styles)(Nav)
